let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dU1a8")).then(() => parcelRequire('1twF2'));